export enum ErrorButtonActionEnum {
  GO_TO_CHAT = 'GO_TO_CHAT',
  CALL_SUPPORT = 'CALL_SUPPORT'
}
